import "./footer.css";
import HelpButton from "../helpButton/helpButton";
import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";


const Footer = (props) => {


  const tmpQuery = `
  {
    homePageCollection(where: {slug: "home-&slug&"}) {
        items{
          helpUrl
        }
    }
  }
  `;
  const location = useLocation();
  const [helpButton, setHelpButton] = React.useState(false);

  useEffect(()=> {
    
    const url = String(location.pathname).split("/");
    let slug = url[1]; 
    // console.log('slug top header', slug)

    if (slug === 'pa') {
      slug = 'pa-old'
    }
    
    const query = tmpQuery.replace('&slug&', slug);
    // console.log('query top Header', query );
    

    window
        .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            // Authenticate the request
            Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
            },
            // send the GraphQL query
            body: JSON.stringify({ query }),
        })
        .then((response) => response.json())
        .then(({ data, errors }) => {
            if (errors) {
              console.error("erros", errors);
            } 
            // console.log ('data footer', data);
            setHelpButton(data.homePageCollection.items[0].helpUrl);
            
        });

  }, [])
  
  return (
    <div className="container-fluid footer-container">
      <div className="container">
        <div className="row">
          <div className="col-footer  col-md-6  d-flex align-items-center justify-content-start">
            <span className="footer-text">{props.data.text || props.data.copyRight}</span>
          </div>
          <div className="col-md-6 col-footer d-flex justify-content-end  align-items-center">
            <div className="row no-padding">
              {props.data.socialMedia?.footerMenu.map((icon, index) => {
                return (
                  <div key={index} className="col">
                    <a href={icon.img_cta} target="_blank" rel="noreferrer">
                      <img
                        className="social-media-icon"
                        src={icon.img_url}
                        alt={icon.img_url}
                      />
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <HelpButton helpButton={helpButton}  />
    </div>
  );
};

export default Footer;
